import React from 'react'
import { RiMenuAddFill } from "react-icons/ri";
import { GoSearch } from "react-icons/go";
import { Saclayout } from '../../../components/SAC Layout/Saclayout';
import Bulkexport from '../../../components/Bulkexport/Bulkexport';
import { AiOutlineDelete } from "react-icons/ai";
import Pagenation from '../../../components/Pagenation/Pagenation';
import { ServiceCatagories } from '../../../components/ServiceCatagories/ServiceCatagories';



export default function ServiceCategoryMgt() {
  
  
  return (
    <div className='p-5'>
      <div className='border-2 w-[100%] rounded-lg shadow-md'>
        <div className='border-b-2 p-4 text-gray-400 text-xl  font-semibold'>
          <h1>Category Managements</h1>
        </div>

        <div className='flex justify-center gap-2 font-semibold mt-5 '>
          <h1 className='text-red-600 text-xl font-semibold'>ZeroMiddleMan</h1>
          <h1 className='text-xl'>Categories</h1>
        </div>

        <div>
          <h1 className='px-[17%] text-sm text-gray-500 mt-1'>ZeroMiddleMan unique classification of products and services allows you to search for companies worldwide by keyword or by code. Companies are classified by activity sector (2-digit code), industry (5 digits) or product/service (7 digits)</h1>
        </div>

        <div className='flex justify-center mt-7 gap-4 text-gray-400'>
          <div className='flex'>
            <h1><RiMenuAddFill className='text-xl' /></h1>
            <h1 > this is Add HSN </h1>
          </div>

          <div className='flex'>
            <h1><AiOutlineDelete className='text-xl h-full' /></h1>
            <h1>this is Delete HSN </h1>
          </div>
        </div>
        <div className="border-2 w-[65%] ms-48 p-4 rounded-lg shadow-md border-b mt-4 ">
          <div className='flex gap-2 p-1 border-b-2 pb-3 w-[98%] '>
            <div className="border border-gray-500 flex justify-end rounded-full  w-[62%] h-10 ">
              <button className="bg-red-600  text-white px-6 py-2 gap-3 flex rounded-full hover:bg-red-600"><h1><GoSearch className='text-lg mt-1' /></h1>
                Search
              </button>
            </div>
            <div>
              <div className='text-blue-600 border border-blue-600 rounded-lg px-6 py-1.5  mt-0.5   '>clear </div>
            </div>

            <div className=' mt-0.5'>
             <Bulkexport/>
            </div>

            <div >
              <h1 className='text-2xl text-white bg-red-500 rounded-md ms-4 mt-1.5 p-1 hover:cursor-pointer'><AiOutlineDelete /></h1>
            </div>
          </div>
          
          {/* Open dropdown ..----------- */}
          <div className=''>
           <ServiceCatagories/>
          </div>
        </div>
        <div className='ms-48 mt-3 mb-4'>
          <Pagenation/>
        </div>
      </div>
    </div>
  )
}
